import { render } from "./Patreon.vue?vue&type=template&id=42f68554"
import script from "./Patreon.vue?vue&type=script&lang=js"
export * from "./Patreon.vue?vue&type=script&lang=js"
script.render = render

export default script